// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive layout for PlanningWrapper and NextActionsContainer */
.nextActionsContainerGraphOnly {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;
  padding-left: 24px;
  padding-right: 0px;
}

@media (max-width: 1560px) {
  .nextActionsContainerGraphOnly {
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
    padding-right: 16px;
  }
  .nextActionsContainerGraphOnly > div {
    min-width: 0;
    flex: 1 1 0;
  }
}

/* Optionally, tweak child widths for best fit on mobile */
@media (max-width: 600px) {
  .nextActionsContainerGraphOnly {
    flex-direction: column;
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/dashboardNextActionsContainerGraphOnly.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,MAAM;EACN,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":["/* Responsive layout for PlanningWrapper and NextActionsContainer */\n.nextActionsContainerGraphOnly {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 0;\n  padding-left: 24px;\n  padding-right: 0px;\n}\n\n@media (max-width: 1560px) {\n  .nextActionsContainerGraphOnly {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 16px;\n    padding-right: 16px;\n  }\n  .nextActionsContainerGraphOnly > div {\n    min-width: 0;\n    flex: 1 1 0;\n  }\n}\n\n/* Optionally, tweak child widths for best fit on mobile */\n@media (max-width: 600px) {\n  .nextActionsContainerGraphOnly {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
